import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import useDebounce from '../../components/global/use-debounce';

const useStyles = makeStyles((theme) => ({
  root: {
    padding:    '2px 4px',
    display:    'flex',
    alignItems: 'center',
    width:      400,
  },
  input: {
    marginLeft: theme.spacing(1),
    flex:       1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

export default function SearchBar({ style, label, onSearch, onAdd }) {
  const [searchBrand, setSearchBrand] = useState('');
  const classes = useStyles();

  const debouncedSearch = useDebounce(searchBrand, 500);

  const addButton =  (typeof onAdd === 'undefined') ? '' : (
    <>
      <Divider className={classes.divider} orientation="vertical" />
      <IconButton onClick={onAdd} color="primary" className={classes.iconButton} aria-label="directions">
        <AddCircleIcon />
      </IconButton>
    </>
  );

  const onChange = (key) => {
    setSearchBrand(key);
    onSearch(key);
  };

  useEffect(() => {
    onChange(searchBrand);
  }, [debouncedSearch]);

  return (
    <Paper component="form" className={classes.root} style={style}>
      <InputBase
        className={classes.input || style}
        placeholder={label}
        autoFocus
        onChange={(e) => setSearchBrand(e.target.value)}
        inputProps={{ 'aria-label': label }}
      />
      <IconButton onClick={() => { onSearch(searchBrand); }} className={classes.iconButton} aria-label="search">
        <SearchIcon />
      </IconButton>
      {addButton}
    </Paper>
  );
}
